import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Only scroll to top on new navigation (not on back/forward)
    if (navigationType === "PUSH") {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, navigationType]);

  return null;
}
